import script from "./DialogOkModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogOkModal.vue?vue&type=script&setup=true&lang=js"

import "./DialogOkModal.vue?vue&type=style&index=0&id=4b21942a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b21942a"]])

export default __exports__